import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';

export const CardContainer = styled(FlexContainer)`
  flex-wrap: wrap;
  justify-content: center;
`;

export const CardNumber = styled(FlexContainer)`
  position: absolute;
  top: ${({ theme: { sizing } }) => `-${sizing.fds_size_16}`};
  left: ${({ theme: { sizing } }) => `-${sizing.fds_size_16}`};
  background: ${({ theme: { colors } }) => colors.tax_500};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_round};
  height: ${({ theme: { sizing } }) => sizing.fds_size_40};
  width: ${({ theme: { sizing } }) => sizing.fds_size_40};
`;

export const Card = styled(FlexContainer)`
  position: relative;
  background: ${({ theme: { colors } }) => colors.white};
  width: 293px;
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  border: 1px solid ${({ theme: { colors } }) => colors.sky_300};
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_32} ${sizing.fds_size_16}`};
`;
